import React from "react";

import {
  ChatRounded,
  DeleteRounded,
  DirectionsBusRounded,
  KeyboardArrowDownRounded,
  KeyboardArrowUpRounded,
  RestaurantRounded,
  SaveRounded,
} from "@mui/icons-material";
import { Box, IconButton } from "@mui/material";

import { CustomItemSchedule } from "../..";
import SwitchMain from "../../../../../../../components/InputMain/SwitchMain";
import TextMain from "../../../../../../../components/InputMain/TextMain";
import MainSolidButton from "../../../../../../../components/MainSolidButton";
import { GreyPallet } from "../../../../../../../config/styles";

export default function TimeItem({
  item,
  setter,
}: {
  item: CustomItemSchedule;
  setter: React.Dispatch<React.SetStateAction<CustomItemSchedule[]>>;
}) {
  const [open, setOpen] = React.useState(false);

  const [valueField, setValueField] = React.useState(item.value || "");
  const [ruField, setRuField] = React.useState(item.ru || false);
  const [terminalField, setTerminalField] = React.useState(item.terminal || false);
  const [companyField, setCompanyField] = React.useState(item.company || "");

  const isDifferent =
    valueField !== item.value ||
    ruField !== item.ru ||
    terminalField !== item.terminal ||
    companyField !== item.company;

  const handleSave = () => {
    setter((prevState: CustomItemSchedule[]) => {
      const newState = prevState.map((oldItem) => {
        return oldItem.id === item.id
          ? {
              id: item.id,
              value: valueField,
              ru: ruField,
              terminal: terminalField,
              company: companyField,
            }
          : oldItem;
      });
      const orderedState = newState.sort((a, b) =>
        a.value > b.value ? 1 : b.value > a.value ? -1 : 0
      );
      return orderedState;
    });
  };

  const handleDelete = () => {
    setter((prevState: CustomItemSchedule[]) => {
      const newState = prevState.filter((oldItem) => {
        return oldItem.id !== item.id;
      });

      return newState;
    });
  };

  return (
    <Box
      sx={{
        border: "3px solid " + GreyPallet.Light,
        borderRadius: "10px",
        color: GreyPallet.Regular,
        px: 1,
        pt: 1,
        mb: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Box width={"100%"} display={"flex"} alignItems={"center"} gap={1}>
          <TextMain
            inputMode={"decimal"}
            textColor={"regular"}
            name="Hora"
            onChange={(value) =>
              setValueField(value.replace(".", ":").replace(",", ":").slice(0, 5))
            }
            value={valueField}
          />
          {!!ruField && <RestaurantRounded sx={{ fontSize: 16 }} />}
          {!!terminalField && <DirectionsBusRounded sx={{ fontSize: 16 }} />}
          {!!companyField && <ChatRounded sx={{ fontSize: 16 }} />}
        </Box>

        {isDifferent && (
          <IconButton size="small" onClick={handleSave}>
            <SaveRounded />
          </IconButton>
        )}

        <IconButton size="small" onClick={() => setOpen(!open)}>
          {open ? <KeyboardArrowUpRounded /> : <KeyboardArrowDownRounded />}
        </IconButton>
      </Box>

      {open && (
        <Box width={"100%"}>
          <Box mb={2}>
            <SwitchMain name="RU" checked={ruField} noBottom onChange={setRuField} />
          </Box>

          <Box mb={2}>
            <SwitchMain
              name="Terminal"
              checked={terminalField}
              noBottom
              onChange={setTerminalField}
            />
          </Box>

          <TextMain
            textColor={"regular"}
            name="Companhia"
            onChange={setCompanyField}
            value={companyField}
          />

          <Box mb={2}>
            <MainSolidButton
              small
              color="error"
              text={"Remover"}
              icon={<DeleteRounded />}
              onClick={handleDelete}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
}
